import {ScriptsProvider} from '../providers/scriptsProvider';

class LazyGoogleAdsense
{
    static load() {
        let googleAdsenseMeta = document.querySelector('[data-script="google-adsense"]');

        if (googleAdsenseMeta) {
            ScriptsProvider.addWithAttributes('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
                'data-ad-client': googleAdsenseMeta.getAttribute('data-id'),
            });
        }
    }
}

export {LazyGoogleAdsense};
